import { RefObject } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { ReportsItem } from '@/hooks'
import { ReportingTableLabelsMap } from './useReportingTableLabelsMap'
import { ActionsCell } from './ActionsCell/ActionsCell'
import { formatRelativeTimeAndDateCell } from '@/components/common/Table/utils'
import { TruncatableText } from '@/components/molecules/TruncatableText/TruncatableText'

export const getColumns = (
    labelsMap: ReportingTableLabelsMap,
    containerRef?: RefObject<HTMLDivElement>
): ColumnDef<ReportsItem>[] => {
    const columns: ColumnDef<ReportsItem>[] = [
        {
            id: 'name',
            accessorKey: 'name',
            header: labelsMap['name'],
            cell: ({ cell }) => {
                const cellValue = cell.getValue()

                if (typeof cellValue === 'string') {
                    return (
                        <TruncatableText
                            text={cellValue}
                            tooltipClassname="max-w-tooltipWidth break-words"
                        />
                    )
                }
            },
        },
        {
            id: 'owner.name',
            accessorKey: 'owner',
            header: labelsMap['owner'],
            cell: ({ cell }) => {
                const cellValue = cell.getValue()

                if (typeof cellValue === 'object' && cellValue !== null) {
                    const ownerName = cellValue as ReportsItem['owner']

                    return ownerName.name
                }
            },
        },
        {
            id: 'updatedAt',
            accessorKey: 'updatedAt',
            header: labelsMap['updatedAt'],
            sortingFn: 'datetime',
            cell: formatRelativeTimeAndDateCell as ColumnDef<ReportsItem>['cell'],
        },
        {
            id: 'actions',
            cell: (props) => {
                return <ActionsCell {...props} containerRef={containerRef} />
            },
            enableSorting: false,
        },
    ]

    return columns
}
